import React, { useRef } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Box,
  TextField,
} from "@mui/material";

const AddGoogleNumber = ({
  googleAddnumber,
  google_Pop_flag,
  closePop,
  number,
  setNumber,
  numberError,
  numberErrorMsg,
}) => {
  const inputRef = useRef(null);

  const handleNumber = (e) => {
    let value = e.target.value;

    // Allow only digits
    value = value.replace(/\D/g, "");

    // Limit to 10 digits
    value = value.slice(0, 10);

    setNumber(value);
  };

  const handlePaste = (e) => {
    const pastedData = e.clipboardData.getData("text");

    // Prevent paste if contains non-digits
    if (!/^\d+$/.test(pastedData)) {
      e.preventDefault();
      return;
    }

    // Prevent paste if length exceeds 10
    if ((number?.length || 0) + pastedData.length > 10) {
      e.preventDefault();
    }
  };

  // Valid Indian mobile number (exactly 10 digits)
  const isValidNumber = /^[0-9]{10}$/.test(number || "");

  return (
    <Dialog
      open={google_Pop_flag}
      onClose={closePop}
      PaperProps={{
        sx: {
          borderRadius: 3,
          width: "90%",
          maxWidth: 380,
          textAlign: "center",
          p: 2,
        },
      }}
    >
      <DialogContent>
        {/* Header SVG */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
          <svg
            style={{ width: "90px" }}
            xmlns="http://www.w3.org/2000/svg"
            width="124"
            height="124"
            viewBox="0 0 124 124"
            fill="none"
          >
            <g clipPath="url(#clip0_83_382)">
              <path
                d="M79.4837 103.027C102.384 93.125 112.921 66.5329 103.019 43.6324C93.1164 20.732 66.5243 10.195 43.6238 20.0974C20.7233 29.9998 10.1863 56.5919 20.0888 79.4924C29.9912 102.393 56.5832 112.93 79.4837 103.027Z"
                fill="#009846"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M45.9086 38.8813L53.7773 45.6473C53.7773 45.6473 55.6852 47.8822 54.5372 49.9086C48.2219 61.1602 65.447 75.9554 75.6141 68.0047C77.4648 66.569 79.9435 68.1099 79.9435 68.1099L87.8122 74.8758C93.2011 78.9009 80.8114 88.1892 71.4763 84.9996C62.749 82.018 54.1075 74.0091 53.012 72.9999C51.8431 72.0931 42.6223 64.7585 38.3547 56.5766C33.7987 47.8368 41.0905 34.1622 45.8888 38.8899L45.9086 38.8813Z"
                fill="#FEFEFE"
              />
            </g>
            <defs>
              <clipPath id="clip0_83_382">
                <rect
                  width="93.6566"
                  height="93.6566"
                  fill="white"
                  transform="translate(0 37.1719) rotate(-23.3842)"
                />
              </clipPath>
            </defs>
          </svg>
        </Box>

        {/* Title */}
        <Typography variant="h6" fontWeight={700}>
          Verify Your Number
        </Typography>

        <Typography
          variant="body2"
          sx={{
            mt: 1.5,
            color: "#475569",
            width: "85%",
            mx: "auto",
          }}
        >
          Please enter your phone number to link it and continue to payment.
        </Typography>

        {/* Mobile Number Input */}
        <Box sx={{ mt: 3 }}>
          <TextField
            inputRef={inputRef}
            type="text"
            placeholder="Enter 10-digit Mobile Number"
            value={number || ""}
            onChange={handleNumber}
            onPaste={handlePaste}
            fullWidth
            autoComplete="off"
            inputProps={{
              maxLength: 10,
              inputMode: "numeric",
              pattern: "[0-9]*",
              style: {
                textAlign: "center",
                fontSize: "16px",
              },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                border: "2px solid #8080805e",
              },
            }}
          />

          {numberError && (
            <Typography
              variant="caption"
              sx={{
                color: "rgba(234,67,53,1)",
                textAlign: "left",
                display: "block",
                mt: 1,
              }}
            >
              {numberErrorMsg}
            </Typography>
          )}
        </Box>

        {/* Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 4,
          }}
        >
          <Button
            onClick={closePop}
            variant="outlined"
            sx={{
              borderColor: "rgba(0,177,119,1)",
              color: "rgba(0,177,119,1)",
              borderRadius: "10px",
              width: "48%",
              fontWeight: 600,
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={googleAddnumber}
            variant="contained"
            disabled={!isValidNumber}
            sx={{
              backgroundColor: isValidNumber
                ? "rgba(0,177,119,1)"
                : "rgba(0,177,119,0.5)",
              borderRadius: "10px",
              width: "48%",
              fontWeight: 700,
              color: "#fff",
              "&:hover": {
                backgroundColor: isValidNumber
                  ? "rgba(0,150,100,1)"
                  : "rgba(0,177,119,0.5)",
              },
            }}
          >
            Continue
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AddGoogleNumber;